/* ============================================================
   MM: Kernabschnitt - Aura, Bildtausch, Scroll-Ausloeser
   ============================================================ */
(function () {
  'use strict';

  var SECTION_MATCH = '[id*="__product_list_qNCwRf"]';

  var IMAGES = [
    'https://cdn.shopify.com/s/files/1/0533/7825/2996/files/rn-image_picker_lib_temp_93012c2d-c1ee-4377-b43e-4cd5cb8919ca.png?v=1787604071&width=600',
    'https://cdn.shopify.com/s/files/1/0533/7825/2996/files/rn-image_picker_lib_temp_98529641-422a-4af8-b18e-691b063ecb9a.png?v=1787604072&width=600',
    'https://cdn.shopify.com/s/files/1/0533/7825/2996/files/rn-image_picker_lib_temp_5ef66d98-6760-442f-a666-ace1abb1b246.png?v=1787604070&width=600'
  ];

  function clearBackgrounds(fromNode, stopNode) {
    var node = fromNode;
    var steps = 0;
    while (node && node !== stopNode && steps < 7) {
      node.style.background = 'transparent';
      node.style.backgroundColor = 'transparent';
      node.style.border = 'none';
      node = node.parentElement;
      steps++;
    }
  }

  function apply() {
    var section = document.querySelector(SECTION_MATCH);
    if (!section) return;

    var cards = section.querySelectorAll('.product-card');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card, index) {
      if (index >= IMAGES.length) return;
      if (card.dataset.mmCore === 'done') return;
      card.dataset.mmCore = 'done';

      card.classList.add('mm-core-item', 'mm-core-' + (index + 1));
      if (getComputedStyle(card).position === 'static') {
        card.style.position = 'relative';
      }

      var imgs = card.querySelectorAll('img');
      var firstImg = null;

      Array.prototype.forEach.call(imgs, function (img) {
        if (img.closest('.mm-wishlist-btn')) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('draggable', 'false');
        img.src = IMAGES[index];
        img.style.objectFit = 'contain';
        img.style.background = 'transparent';
        img.classList.add('mm-core-front');
        clearBackgrounds(img.parentElement, card);
        if (!firstImg) firstImg = img;
      });

      if (!firstImg) return;

      var aura = document.createElement('img');
      aura.src = IMAGES[index];
      aura.alt = '';
      aura.setAttribute('aria-hidden', 'true');
      aura.setAttribute('draggable', 'false');
      aura.className = 'mm-core-aura';
      card.insertBefore(aura, card.firstChild);

      var ghost = document.createElement('img');
      ghost.src = IMAGES[index];
      ghost.alt = '';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.setAttribute('draggable', 'false');
      ghost.className = 'mm-core-ghost';
      card.appendChild(ghost);

      function place() {
        var cardRect = card.getBoundingClientRect();
        var imgRect = firstImg.getBoundingClientRect();
        if (!imgRect.height) return;
        var top = imgRect.top - cardRect.top;
        aura.style.top = top + 'px';
        aura.style.height = imgRect.height + 'px';
        ghost.style.top = top + 'px';
        ghost.style.height = imgRect.height + 'px';
      }

      if (firstImg.complete) place();
      else firstImg.addEventListener('load', place);
      window.addEventListener('resize', place);
      setTimeout(place, 400);
      setTimeout(place, 1200);
    });

    watchScroll(section);
  }

  function watchScroll(section) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var cards = section.querySelectorAll('.mm-core-item');
    if (!cards.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        observer.unobserve(card);
        card.classList.remove('mm-core-flare');
        void card.offsetWidth;
        card.classList.add('mm-core-flare');
        setTimeout(function () {
          card.classList.remove('mm-core-flare');
        }, 1500);
      });
    }, { threshold: 0.4, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.mmFlareWatched === '1') return;
      card.dataset.mmFlareWatched = '1';
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', apply);
  window.addEventListener('load', apply);
})();

/* ============================================================
   MM: Newsletter-Bestaetigungsseite /account/subscribe
   ============================================================ */
(function () {
  'use strict';

  if (location.pathname.indexOf('/account/subscribe') === -1) return;

  function build() {
    var main = document.querySelector('main') || document.querySelector('#MainContent');
    if (!main || main.dataset.mmSub === '1') return;
    main.dataset.mmSub = '1';

    var box = document.createElement('div');
    box.setAttribute('style', 'background:#0A0A0A;color:#F2ECF5;padding:64px 20px 72px;text-align:center;font-family:"Space Grotesk",system-ui,sans-serif');

    box.innerHTML =
      '<p style="color:#5EC752;font-size:12px;font-weight:700;letter-spacing:.32em;margin:0 0 18px">SUBSCRIBED</p>' +
      '<h1 style="font-family:Fraunces,Georgia,serif;font-weight:900;font-size:clamp(38px,11vw,64px);line-height:.92;margin:0 0 18px;color:#F2ECF5;text-transform:none">YOU&rsquo;RE IN.</h1>' +
      '<p style="font-size:16px;line-height:1.6;max-width:30ch;margin:0 auto 36px;color:rgba(242,236,245,.75)">You are on the list. Here is what that gets you.</p>' +
      '<div style="max-width:420px;margin:0 auto 40px;text-align:left">' +
        '<div style="display:flex;gap:16px;padding:16px 4px;border-top:1px solid rgba(242,236,245,.14)">' +
          '<span style="color:#5EC752;font-weight:700;font-size:14px;min-width:26px">01</span>' +
          '<span style="font-size:15px;line-height:1.5"><b>Drops first.</b><br><span style="color:rgba(242,236,245,.6);font-size:14px">You see new pieces before they go public.</span></span>' +
        '</div>' +
        '<div style="display:flex;gap:16px;padding:16px 4px;border-top:1px solid rgba(242,236,245,.14)">' +
          '<span style="color:#5EC752;font-weight:700;font-size:14px;min-width:26px">02</span>' +
          '<span style="font-size:15px;line-height:1.5"><b>Codes nobody else gets.</b><br><span style="color:rgba(242,236,245,.6);font-size:14px">Discounts that never touch the shop pages.</span></span>' +
        '</div>' +
        '<div style="display:flex;gap:16px;padding:16px 4px;border-top:1px solid rgba(242,236,245,.14);border-bottom:1px solid rgba(242,236,245,.14)">' +
          '<span style="color:#5EC752;font-weight:700;font-size:14px;min-width:26px">03</span>' +
          '<span style="font-size:15px;line-height:1.5"><b>Inside the workshop.</b><br><span style="color:rgba(242,236,245,.6);font-size:14px">How every piece is cut, sealed and stitched by hand.</span></span>' +
        '</div>' +
      '</div>' +
      '<a href="/collections/all" style="display:inline-block;background:#FF8DDC;color:#0A0A0A;padding:17px 48px;text-decoration:none;font-weight:700;font-size:15px;letter-spacing:.12em">SHOP THE DROP</a>' +
      '<p style="font-size:12px;color:rgba(242,236,245,.4);margin:34px 0 0;letter-spacing:.2em">BE MAINEY. BE MORE.</p>';

    main.insertBefore(box, main.firstChild);

    Array.prototype.forEach.call(main.children, function (node) {
      if (node === box) return;
      node.style.fontSize = '11px';
      node.style.opacity = '.4';
      node.style.textAlign = 'center';
      node.style.padding = '10px 20px 40px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  window.addEventListener('load', build);
})();

/* ============================================================
   MM: Beschreibung nach oben holen
   ============================================================ */
(function () {
  'use strict';

  function move() {
    var lang = document.querySelector('.mm-lang[data-lang]');
    if (!lang) return;

    var anchor = document.querySelector('.mm-sizeguide-trigger');
    if (!anchor) return;

    var anchorBlock = anchor;
    var descBlock = lang;

    while (anchorBlock.parentElement && anchorBlock.parentElement !== document.body) {
      if (anchorBlock.parentElement.contains(descBlock) === false) {
        anchorBlock = anchorBlock.parentElement;
        continue;
      }
      break;
    }

    var container = anchorBlock.parentElement;
    if (!container) return;

    while (descBlock.parentElement && descBlock.parentElement !== container) {
      descBlock = descBlock.parentElement;
    }
    if (!descBlock.parentElement) return;
    if (descBlock.dataset.mmMoved === '1') return;

    descBlock.dataset.mmMoved = '1';
    container.insertBefore(descBlock, anchorBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', move);
  } else {
    move();
  }
  document.addEventListener('shopify:section:load', move);
  window.addEventListener('load', move);
})();

/* ============================================================
   MM: Sprachumschalter in der Produktbeschreibung
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'mm_desc_lang';

  function preferred() {
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved === 'de' || saved === 'en') return saved;
    var nav = (navigator.language || 'en').toLowerCase();
    return nav.indexOf('de') === 0 ? 'de' : 'en';
  }

  function build() {
    var blocks = document.querySelectorAll('.mm-lang[data-lang]');
    if (!blocks.length) return;

    var groups = [];
    Array.prototype.forEach.call(blocks, function (b) {
      if (groups.indexOf(b.parentElement) === -1) groups.push(b.parentElement);
    });

    groups.forEach(function (parent) {
      if (parent.dataset.mmLangInit === '1') return;
      parent.dataset.mmLangInit = '1';

      var mine = parent.querySelectorAll(':scope > .mm-lang[data-lang]');
      if (mine.length < 2) return;

      var bar = document.createElement('div');
      bar.setAttribute('style', 'display:flex;align-items:center;gap:8px;margin:0 0 16px');

      var globe = document.createElement('span');
      globe.setAttribute('aria-hidden', 'true');
      globe.setAttribute('style', 'opacity:.55;font-size:14px;line-height:1');
      globe.textContent = '⊕';
      bar.appendChild(globe);

      var buttons = {};

      ['en', 'de'].forEach(function (code) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = code.toUpperCase();
        btn.setAttribute('aria-label', code === 'en' ? 'English description' : 'Deutsche Beschreibung');
        btn.setAttribute('style', 'cursor:pointer;font:inherit;font-size:12px;letter-spacing:.08em;padding:5px 12px;border:1px solid currentColor;background:transparent;color:inherit;border-radius:2px;line-height:1.4');
        btn.addEventListener('click', function () {
          set(code);
          try { localStorage.setItem(KEY, code); } catch (e) {}
        });
        buttons[code] = btn;
        bar.appendChild(btn);
      });

      function set(code) {
        Array.prototype.forEach.call(mine, function (b) {
          b.style.display = b.getAttribute('data-lang') === code ? '' : 'none';
        });
        ['en', 'de'].forEach(function (c) {
          var on = c === code;
          buttons[c].style.opacity = on ? '1' : '.45';
          buttons[c].style.fontWeight = on ? '700' : '400';
          buttons[c].setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      parent.insertBefore(bar, mine[0]);
      set(preferred());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  document.addEventListener('shopify:section:load', build);
  window.addEventListener('load', build);
})();

/* ============================================================
   MM: Textbereich der Produktkacheln zusammenfassen
   ============================================================ */
(function () {
  'use strict';

  function wrap() {
    var cards = document.querySelectorAll('.product-grid .product-card:not(.mm-core-item)');
    if (!cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.mmText === '1') return;

      var content = card.querySelector('.product-card__content');
      if (!content) return;

      var kids = Array.prototype.slice.call(content.children);
      var gallery = content.querySelector('.card-gallery');
      var galleryTop = gallery;
      while (galleryTop && galleryTop.parentElement !== content) {
        galleryTop = galleryTop.parentElement;
      }

      var after = [];
      var seen = false;
      kids.forEach(function (kid) {
        if (kid === galleryTop) { seen = true; return; }
        if (seen) after.push(kid);
      });

      if (!after.length) return;

      card.dataset.mmText = '1';

      var box = document.createElement('div');
      box.className = 'mm-card-text';
      content.insertBefore(box, after[0]);
      after.forEach(function (kid) { box.appendChild(kid); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrap);
  } else {
    wrap();
  }
  document.addEventListener('shopify:section:load', wrap);
  window.addEventListener('load', wrap);

  /* Nachgeladene Karten (Endlos-Scrollen, Filter, Sortierung) ebenfalls
     zusammenfassen. Sonst bleiben sie auf dem Theme-Standard (dunkle Schrift). */
  var wrapQueued = false;
  function queueWrap() {
    if (wrapQueued) return;
    wrapQueued = true;
    requestAnimationFrame(function () {
      wrapQueued = false;
      wrap();
    });
  }

  function hasCard(node) {
    return node.nodeType === 1 && (node.matches('.product-card') || node.querySelector('.product-card'));
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (hasCard(added[j])) { queueWrap(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
